import React from "react";
import "./styles.scss";
import { FormCheck } from "..";

const Index = ({ data, onClick }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div
        className={`advCheckBox-wrapper ${data.isActive ? "active-me" : ""}${
          data.error ? "validation-on" : ""
        } `}
        onClick={onClick}
      >
        <FormCheck
          data={{ iconName: "check", isSelect: data.isActive ? true : false }}
        />

        <div className="acw-web-header">
          <div style={{ marginLeft: "5px", display: "flex", gap: "3px" }}>
            {" "}
            <div className="wh-line-icon"></div>
            <div className="wh-line-icon"></div>
            <div className="wh-line-icon"></div>
          </div>
        </div>

        {data.type === "header" && (
          <div className="wiw-banner">
            {/* <div className="bg-color"></div> */}
            <div className="wiw-text-header-wrapper">
              <div className="wiw-text">
                Ad space{" "}
                <span style={{ color: " #000000", fontSize: "8px" }}>
                  728x90
                </span>
              </div>
            </div>
          </div>
        )}
        {data.type === "slider" && (
          <div className="wiw-banner">
            {/* <div className="bg-color"></div> */}
            <div className="wiw-text-slider-wrapper">
              <div className="wiw-text">
                Ad space
                <div style={{ color: " #000000", fontSize: "8px" }}>
                  620x620
                </div>
              </div>
            </div>
          </div>
        )}

        <div className={"acw__checkName d-flex align-items-center"}>
          {data.checkName}
        </div>
      </div>
    </>
  );

  return <>{inputElement}</>;
};

Index.propTypes = {};

Index.defaultProps = {};

export default Index;
